<div class="filters-and-search-container">
  <div class="filter-search-container">
    <div class="filter-search">
      <input placeholder=" Search filters" [(ngModel)]="searchString" name="searchString"
        (keypress)="checkForEnterKey($event)" class="filter-search-input">
      <button class="filter-search-button" (click)="search()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" width="14px" height="14px"
          style="fill: #b8b8b8;">
          <path
            d="M15.7574 14.7187L11.5687 10.5312C12.4752 9.42187 12.9754 8.025 12.9754 6.5C12.9754 2.90937 10.0643 0 6.47362 0C2.88297 0 0 2.91031 0 6.5C0 10.0897 2.91079 13 6.47362 13C7.99871 13 9.39784 12.4716 10.506 11.5925L14.6946 15.78C14.8696 15.9281 15.0634 16 15.2541 16C15.4448 16 15.638 15.9267 15.7846 15.7803C16.0762 15.4875 16.0762 15.0125 15.7574 14.7187ZM1.50041 6.5C1.50041 3.74312 3.74414 1.5 6.50175 1.5C9.25937 1.5 11.5031 3.74312 11.5031 6.5C11.5031 9.25687 9.25937 11.5 6.50175 11.5C3.74414 11.5 1.50041 9.25625 1.50041 6.5Z">
          </path>
        </svg>
      </button>
    </div>
    <div *ngIf="searchActive" class="search-back-container">
        <a href="javascript:void(0)" (click)="clearSearch()" class="search-back-link">< Clear search</a>
    </div>
  </div>

  <div class="filters-container">
    <a *ngFor="let filter of filterEntries; let n = index;" href="javascript:void(0)"
      (click)="filterSelected(n)" class="filter-link" [ngClass]="n === selectedFilterIndex ? 'selected' : ''">
      <span class="filter-value" [ngClass]="n === selectedFilterIndex ? 'selected' : ''">{{filter.value}}</span>
    </a>
  </div>
</div>